import moment from 'moment'

export const secondInMs = 1000
export const minuteInMs = secondInMs * 60
export const hourInMs = minuteInMs * 60
export const dayInMs = hourInMs * 24
export const weekInMs = dayInMs * 7


export function format24h (value) {
  return moment(value).format('HH:mm')
}

export function format24hRounded (value, round = 60) {
  let ROUNDING = round * 60 * 1000
  let s = moment(Math.ceil((+moment(value)) / ROUNDING) * ROUNDING)
  return s.format('HH:mm')
}

export function format24hSecs (value) {
  return moment(value).format('HH:mm:ss')
}

export function format12h (value, includeOrdinal) {
  if (includeOrdinal === undefined) {
    includeOrdinal = true
  }
  const formatSring = 'h:mm' + (includeOrdinal ? ' A' : '')
  return moment(value).format(formatSring)
}

export function format12hSecs (value, includeOrdinal) {
  if (includeOrdinal === undefined) {
    includeOrdinal = true
  }
  const formatSring = 'h:mm:ss' + (includeOrdinal ? ' A' : '')
  return moment(value).format(formatSring)
}

export function formatDateTime24h (value) {
  return moment(value).format('DD/MM/YYYY HH:mm')
}

export function formatDateTimeDayMonth24h (value) {
  return moment(value).format('DD/MM HH:mm')
}

export function formatDateTimeDayMonthYear24h (value) {
  return moment(value).format('DD-MM-YY HH:mm')
}

export function formatMysql (value) {
  return moment(value).format('YYYY-MM-DD HH:mm:ss')
}

export function formatDateDayName (value) {
  return moment(value).format('ddd Mo')
}

export function formatDateDayMonth (value) {
  return moment(value).format('Do MMMM')
}

export function formatTimeAgo (value) {
  return moment(value).fromNow()
}

export function formatUntil (value) {
  return moment(value).toNow()
}

export function formatCalendarDay (value) {
  return moment(value).calendar(null, {
      sameDay: '[Today]',
      lastDay: '[Yesterday]',
      lastWeek: '[Last] dddd',
      sameElse: 'DD/MM/YYYY'
  })
}

export function formatCalendar (value) {
  return moment(value).calendar()
}

export function formatCalendar24 (value) {
  return moment(value).calendar(null, {
    sameDay: '[Today] HH:mm',
    lastDay: '[Yesterday] HH:mm',
    lastWeek: '[Last] dddd HH:mm',
    nextDay: '[Tomorrow] HH:mm',
    nextWeek: 'dddd HH:mm',
    sameElse: 'DD/MM/YYYY HH:mm'
  })
}

export function nowAsTimeStamp () {
  return new Date().getTime()
}

export function startOfDay (d) {
  return moment(d).startOf('day').toDate()
}

export function durationFromTimeStamp (milliseconds) {
  return moment.duration(milliseconds)
}

export function formatJson (timestamp) {
  const m = moment(timestamp)
  return {
    'years': m.years(),
    'months': m.months(),
    'weeks': m.weeks(),
    'days': m.days(),
    'hours': m.hours(),
    'minutes': m.minutes(),
    'seconds': m.seconds(),
    'milliseconds': m.milliseconds()
  }
}

export function dateStringAsTimestamp (str) {
  return new Date(str).getTime()
}

export function timestampAsRelative (timestamp, relative = 'to') {
  const m = moment(timestamp)
  if (relative === 'to') {
    return m.toNow()
  } else {
    return m.fromNow()
  }
}

export function timeConversion (millisec, unit) {

    const seconds = (millisec / 1000).toFixed(1)
    const minutes = (millisec / (1000 * 60)).toFixed(1)
    const hours = (millisec / (1000 * 60 * 60)).toFixed(1)
    const days = (millisec / (1000 * 60 * 60 * 24)).toFixed(1)

    return { seconds, minutes, hours, days }[unit]
}

export function isClassLive (start, end, now) {
  return (start - minuteInMs * 0) < now && end > now
}

export function isClassUpcoming (start, end, now) {
  return start > now && start < now + (dayInMs * 3)
}

export function isClassPast (start, end, now) {
  return end < now
}

export function getClassStatus (cls, now) {
  if (cls.cancelled) {
    return 'cancelled'
  }
  if (isClassLive(cls.start, cls.end, now)) {
    return 'live'
  }
  if (isClassUpcoming(cls.start, cls.end, now)) {
    return 'upcoming'
  }
  if (isClassPast(cls.start, cls.end, now)) {
    return 'past'
  }
}

export function formatDuration (ms) {
  const dur = durationFromTimeStamp(ms)
  const durationObj = [
    {
      'label': 'days',
      'value': dur.days(),
      'format': ' days'
    },
    {
      'label': 'hours',
      'value': dur.hours(),
      'format': ':'
    },
    {
      'label': 'minutes',
      'value': dur.minutes() < 10 ? `0${dur.minutes()}` :`${dur.minutes()}`,
      'format': ':'
    },
    {
      'label': 'seconds',
      'value': dur.seconds() < 10 ? `0${dur.seconds()}` :`${dur.seconds()}`,
      'format': ''
    },
  ]

  return durationObj
    .filter((dur) => !!dur.value)
    .map((dur) => `${dur.value}${dur.format}`)
    .join('')

}

export function firstDayOfCurrentMonth (asTimestamp = false) {
  const mObj = moment().startOf('month')
  return asTimestamp ? mObj.valueOf() : mObj
}

export function firstDayOfPreviousMonth (asTimestamp = false) {
  const mObj = firstDayOfCurrentMonth().subtract(1, 'months')
  return asTimestamp ? mObj.valueOf() : mObj
}

export function lastDayOfPreviousMonth (asTimestamp = false) {
  const mObj = firstDayOfCurrentMonth().subtract(1, 'days')
  return asTimestamp ? mObj.valueOf() : mObj
}
